import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

const methodologyData = [
  {
    title: "Strategic Discovery",
    desc: "We analyze your core objectives and market dynamics to build a data-driven roadmap that guarantees scalable growth.",
   
  },
  {
    title: "Execution Phase",
    desc: "Our agile development cycle focuses on high-speed delivery, ensuring your MVP moves from concept to launch seamlessly.",
   
  },
  {
    title: "Performance Optimization",
    desc: "We continuously monitor and refine your digital ecosystem, leveraging real-time analytics to maximize ROI.",
    
  }
];

export default function ProjectStructure() {
    const {theme} =useTheme()
    const img= theme ==="light"?"light-project.png":"dark-project.png"
  return (
 <section className="relative py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] text-gray-900 dark:text-white">

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-primary/10 blur-[120px] sm:blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-orange-300/10 blur-[120px] sm:blur-[140px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]"></div>

      <div className="text-center mb-12 md:mb-16">
                  <h2 className="myheading text-3xl md:text-5xl text-center">
          Operational  {" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
              Methodology
            </span>
          </h2>
        <p className="myparagraph text-gray-500">Beclling strudioekcin with our operational methodology.</p>
      </div>

      {/* Grid ka use karein row ke liye */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {methodologyData.map((item, index) => (
          <div key={index} className="flex flex-row bg-white dark:bg-[#111] p-6 rounded-3xl border border-orange-100 dark:border-gray-800">
            
            {/* Content Section */}
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">{item.title}</h3>
              <p className="text-gray-600 dark:text-gray-400 text-sm text-left mt-1 ">{item.desc}</p>
              
              
            </div>

            {/* Image Section */}
            <div className="h-auto w-auto flex-1 items-center justify-center ">
             <img src={img} alt="" className='h-50' />
            </div>
            
          </div>
        ))}
      </div>
    </section>
  );
}